export default {
  language: '中文',
  swap: '兑换',
  buyToken: '购买加密资产',
  security: '代币安全',
  placeholder: '通过交易哈希(Hash)进行查询',
  transDetails: '交易详情',
  status: '状态:',
  statusSuccess: '成功',
  statusFailure: '失败',
  onGoing: '进行中',
  date: '日期:',
  sourceChain: '转出链:',
  chain: '链:',
  destChain: '接收链:',
  sourceHash: '转出哈希:',
  hash: '哈希值:',
  destHash: '接收哈希:',
  fromAddress: '转出地址:',
  toAddress: '接收地址:',
  sendValue: '转出价值:',
  receiveValue: '接收价值:',
  liquidityProvider: '流动性提供者:',
  errorMsg: '查无结果，请确认您输入的哈希值(Hash)是否正确',

  secs: '秒',
  min: '分钟',
  mins: '分钟',
  hr: '小时',
  hrs: '小时',
  day: '天',
  days: '天',
  ago: '以前',

  lightTheme: '浅色主题',
  darkTheme: '深色主题',
  copied: '已复制',
  copyHash: '复制哈希值到剪贴板',
  copySourceHash: '复制转出哈希到剪贴板',
  copyDestHash: '复制接收哈希到剪贴板',
  copySourceAddress: '复制转出地址到剪贴板',
  copyDestAddress: '复制接收地址到剪贴板',
  securityText: '前往查看 token 安全信息',

  wait_deposit_send: '等待存币',
  wait_exchange_push: '正在兑换中',
  wait_exchange_return: '正在兑换中',
  wait_exchange_return_success: '正在兑换中',
  wait_exchange_return_error: '正在兑换中',
  wait_receive_send: '兑换完成，等待发币',
  wait_receive_confirm: '正在发币中',
  wait_receive_confirm_error: '正在发币中',
  wait_refund_send: '等待退币',
  wait_refund_confirm: '退币确认中',
  wait_refund_confirm_error: '退币中',
  refund_complete: '退币完成',
  Confirming: '兑换完成，等待发币',
  Swapping: '正在发币中',
  BigAmount: '大额兑换，需要等待',
  wait_deposit_send_error: '存币失败',
  timeout: '兑换超时',
  ERROR: '兑换失败',
  error_hacker: '兑换失败',
  ExceedLimit: '低于兑换限额',
  Failure: '兑换失败',
  question: '遇到问题？联系我们',
  desc1: 'Transit 客服不会私聊您！',
  desc2:
    '请注意，您即将进入Transit社区，您进入社区可能会有人假冒Transit的工作人员私聊您，请您务必警惕，所有私聊您的都可能是骗子！Transit工作人员不会主动跟您私信！',
  desc3: '知道了，继续前往',
  
  receive: '领取',
  received: '已领取',
  connectWallet: '链接钱包',
  claimSuccessful: '领取成功',
  claimFailed: '领取失败',
}
